import React, { createContext, useContext, useEffect, useState } from "react";
import OfflineScreen from "../Error/OfflineScreen";
import { AnimatePresence } from "framer-motion";

interface NetworkContextType {
  isOnline: boolean;
}

const NetworkContext = createContext<NetworkContextType>({ isOnline: true });

export const useNetworkStatus = () => useContext(NetworkContext);

export const NetworkProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <NetworkContext.Provider value={{ isOnline }}>
      <AnimatePresence>
        {!isOnline && (
          <OfflineScreen onRetry={() => setIsOnline(navigator.onLine)} />
        )}
      </AnimatePresence>
      <div style={{ display: isOnline ? "block" : "none", height: "100%" }}>
        {children}
      </div>
    </NetworkContext.Provider>
  );
};
